import { createI18n } from 'vue-i18n';

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
    const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key).default;
        }
    });
    return messages;
}

function getBrowserLocale(options = {}) {
    const defaultOptions = { countryCodeOnly: false };

    const opt = { ...defaultOptions, ...options };

    const navigatorLocale =
        navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

    if (!navigatorLocale) return undefined;

    const trimmedLocale = opt.countryCodeOnly
        ? navigatorLocale.trim().split(/-|_/)[0]
        : navigatorLocale.trim();

    return trimmedLocale;
}

function getStartingLocale() {
    const browserLocale = getBrowserLocale({ countryCodeOnly: true });
    const supportedLocales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');

    if (supportedLocales.includes(browserLocale)) return browserLocale;
    else return process.env.VUE_APP_I18N_LOCALE || 'en';
}

const i18n = createI18n({
    legacy: false,
    locale: getStartingLocale(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages(),
    globalInjection: true
});

export const $t = i18n.global.t;

export default i18n;
